import { SVGProps, Ref, forwardRef } from 'react';

export const PrinterFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 1h15v5h-15zm14 14.8h-13V23h13zm1.8 4.034V14H3.7v5.834C.736 19.412.074 18.028 0 14c.096-5.225 1.182-6 6.997-6h10.006c5.815 0 6.901.775 6.997 6-.074 4.028-.736 5.411-3.7 5.834"
                fill="currentColor"
            />
        </g>
    </svg>
));
PrinterFilledSize24Glyph.displayName = 'PrinterFilledSize24Glyph';
